export default abstract class Feedable {
    constructor(options?: any) {
        this.feed(options)
    }

    public abstract feed(options?: any): this
}
